if (typeof NutritionalInfo !== 'function') {

  class NutritionalInfo extends HTMLElement {
    constructor() {
      super();
      let contentDOM = '';
      let content = this.innerHTML;
      let titleFlag = false;

      // Clean up and split content
      content = content.replace(/<\/p>|<\/div>/g, '').split('<p>');

      contentDOM += `<table><tbody class="table">`;

      // Check for title labels
      if (this.dataset.titleLabelLeft || this.dataset.titleLabelRight) {
        if (!titleFlag) {
          titleFlag = true;
          contentDOM += `<tr class="table-line table-line--heading">`;
          if (this.dataset.titleLabelLeft) {
            contentDOM += `<td class="first_left">${this.dataset.titleLabelLeft}</td><td class="middile"></td>`;
          }
          if (this.dataset.titleLabelRight) {
            contentDOM += `<td class="rightcon">${this.dataset.titleLabelRight}</td>`;
          }
          contentDOM += `</tr>`;
        }
      }

      // Process each section of content
      for (let i = 1; i < content.length; i++) {
        let contentArray = content[i].split(/<br>|<br\/>|\n/g);

                  console.log(contentArray);

        for (let j = 0; j < contentArray.length; j++) {
          if (contentArray[j].trim()) {
            let contentBlockArray = contentArray[j].replaceAll(',', '#SD*@N!SA').split('#SD*@N!SA').map(item => item.trim());

            // Filter out rows where all cells are empty
            if (contentBlockArray.some(cell => cell.length > 0)) {
              contentDOM += `<tr class="table-line custom_cls_nutrition ${(contentArray[j].includes('~') ? 'table-line--indent' : '')}">`;

              for (let k = 0; k < 3; k++) {
                contentDOM += `<td>${contentBlockArray[k] ? contentBlockArray[k].replace('~', '') : ''}</td>`;
              }

              contentDOM += `</tr>`;
            }
          }
        }
      }

      contentDOM += `</tbody></table>`;
      this.innerHTML = contentDOM;
    }
  }

  if (typeof customElements.get('nutritional-info') === 'undefined') {
    customElements.define('nutritional-info', NutritionalInfo);
  }

}
